import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsersPage from "./pages/AdminUsersPage";
import UserProfilePage from "./pages/UserProfilePage";
import EventDetailsPage from "./pages/EventDetailsPage";
import EventParticipantsPage from "./pages/EventParticipantsPage";
import MainEventPage from "./pages/MainEventPage";
import Header from "./components/Header";
import { useAuth } from "./context/AuthContext";
import AccountPage from "./pages/AccountPage";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ChatPage from "./pages/ChatPage";

function AppRoutes({ user, role }) {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/profile" element={<AccountPage />} />
  <Route path="/messages" element={user ? <ChatPage /> : <Navigate to="/login" />} />
      {/* <Route path="/admin/events" element={<AdminEventsPanel />} /> */}
      <Route
        path="/admin/*"
        element={role === "admin" ? <AdminDashboard /> : <Navigate to="/" />}
      />
      <Route
        path="/admin/users"
        element={role === "admin" ? <AdminUsersPage onBack={() => navigate('/admin')} /> : <Navigate to="/" />}
      />
      <Route path="/admin/user/:userId" element={role === "admin" ? <UserProfilePage /> : <Navigate to="/" />} />
  <Route path="/admin/event/:eventId" element={role === "admin" ? <EventDetailsPage /> : <Navigate to="/" />} />
  <Route path="/admin/event/:eventId/participants" element={role === "admin" ? <EventParticipantsPage /> : <Navigate to="/" />} />
      <Route path="/event/:eventId" element={<MainEventPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  const { user, role } = useAuth();
  return (
    <div>
      <Header />
      <AppRoutes user={user} role={role} />
    </div>
  );
}
